// YouTube Integration Settings Page Alpine.js Component
// Handles disconnect modal functionality and tooltip initialization

document.addEventListener('alpine:init', () => {
    Alpine.data('youtube_settings_data', () => ({
        disconnect_modal: false,
        disconnecting: false,

        // Open the disconnect confirmation modal
        open_disconnect_modal() {
            this.disconnect_modal = true;
        },

        // Close the disconnect confirmation modal
        close_disconnect_modal() {
            this.disconnect_modal = false;
        },

        // Handle YouTube integration disconnection
        async disconnect_youtube_account() {
            try {
                // Set loading state
                this.disconnecting = true;

                // Get CSRF token
                const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                const dataEl = document.getElementById("ql-data-points");
                const showId = dataEl.dataset.showId;

                if (!showId) {
                    console.error('Could not determine show ID');
                    alert('Error: Could not determine show ID');
                    this.disconnecting = false;
                    return;
                }

                const response = await fetch(`/shows/${showId}/integrations/youtube/disconnect`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': token
                    }
                });

                const data = await response.json();

                if (data.success) {
                    // Close modal and redirect to show toast message
                    this.close_disconnect_modal();
                    if (data.redirect_url) {
                        window.location.href = data.redirect_url;
                    } else {
                        window.location.reload();
                    }
                } else {
                    alert(`Error: ${data.error || 'Failed to disconnect YouTube account'}`);
                    this.disconnecting = false;
                }
            } catch (error) {
                console.error('Error disconnecting YouTube account:', error);
                alert('Error: Failed to disconnect YouTube account');
                this.disconnecting = false;
            }
        }
    }));
});

// Initialize tooltips after page load
document.addEventListener('DOMContentLoaded', () => {
    // Remove toast query param to prevent repeated notifications
    if (window.location.search.includes('toast=')) {
        const url = new URL(window.location);
        if (url.searchParams.has('toast')) {
            url.searchParams.delete('toast');
            window.history.replaceState(null, '', url.toString());
        }
    }
});
